// @ts-nocheck — 디자인 원본 스크립트 포팅 (home-v3b.js)
import type { Scope } from './scope';

/** 홈: 회전 단어, 아이소 패럴랙스, 질문 흐름 루프, 링, 드래그 빌더(.lab), 사용자 포탈 채팅 데모 */
export function initHomeSections(root: ParentNode, s: Scope) {
  const { setTimeout, setInterval, addEventListener } = s;
  const $ = (sel, r = root) => r.querySelector(sel),
    $$ = (sel, r = root) => [...r.querySelectorAll(sel)];

  /* rotating word */
  const rot = $('.rot');
  if (rot) {
    const sp = $$('span', rot);
    let i = 0;
    rot.style.width = Math.max(...sp.map((el) => el.offsetWidth)) + 'px';
    setInterval(() => {
      i = (i + 1) % sp.length;
      sp.forEach((el) => (el.style.transform = `translateY(${-i * 100}%)`));
    }, 2600);
  }

  /* iso parallax */
  const iso = $('.iso'),
    board = $('.iso .board');
  if (iso && board) {
    iso.addEventListener('mousemove', (e) => {
      const r = iso.getBoundingClientRect(),
        x = (e.clientX - r.left) / r.width - 0.5,
        y = (e.clientY - r.top) / r.height - 0.5;
      board.style.transform = `rotateX(${56 - y * 8}deg) rotateZ(${-42 + x * 8}deg)`;
    });
    iso.addEventListener('mouseleave', () => (board.style.transform = ''));
  }

  /* ask flow loop */
  const fq = $('.flowq');
  if (fq) {
    const items = $$('.stp,.res', fq);
    let T = [];
    const run = () => {
      T.forEach((id) => window.clearTimeout(id));
      T = [];
      items.forEach((e) => e.classList.remove('on'));
      items.forEach((e, k) => T.push(setTimeout(() => e.classList.add('on'), 150 + k * 380)));
      T.push(setTimeout(run, 150 + items.length * 380 + 4000));
    };
    const io = new IntersectionObserver(
      (es) => {
        if (es[0].isIntersecting) {
          run();
          io.disconnect();
        }
      },
      { threshold: 0.1 },
    );
    io.observe(fq);
    s.onDispose(() => io.disconnect());
  }

  /* ring */
  const r = $('.ring');
  if (r) {
    const w = r.closest('.wheel');
    const place = () => {
      const cards = $$('.stx .bc', w);
      if (cards.length < 3) return;
      const rr = r.getBoundingClientRect();
      if (!rr.width || getComputedStyle(w).gridTemplateColumns.split(' ').length < 3) return;
      let d = '';
      $$('.bd', r).forEach((b, i) => {
        const c = cards[i].getBoundingClientRect();
        let y = c.top + c.height / 2 - rr.top;
        y = Math.max(70, Math.min(350, y));
        const dy = y - 210,
          dx = Math.sqrt(Math.max(0, 150 * 150 - dy * dy)),
          left = i < 2,
          x = left ? 210 - dx : 210 + dx;
        b.style.left = x + 'px';
        b.style.top = y + 'px';
        d += left ? `M-32 ${y}H${x - 26}` : `M${x + 26} ${y}H452`;
      });
      $('.cn', r).setAttribute('d', d);
    };
    [0, 400, 1500].forEach((t) => setTimeout(place, t));
    addEventListener('resize', place);
    addEventListener('load', place);
    w.addEventListener('transitionend', place);
  }

  /* builder */
  const lab = $('.lab');
  if (lab) {
    const flow = $('.flow', lab),
      empty = $('.empty', lab),
      res = $('.res', lab),
      st = $('.st', lab),
      stb = $('.st b', lab);
    const N = {
      chat: ['채팅 시작', '트리거', 'var(--grn)', 'msg'],
      sch: ['스케줄', '트리거', 'var(--org)', 'clock'],
      doc: ['문서 검색', '액션', 'var(--blu)', 'doc'],
      ai: ['AI 응답 (LLM)', '액션', 'var(--pnk)', 'spark'],
      judge: ['판단', '액션', '#F97316', 'branch'],
      mail: ['이메일 커넥터', '커넥터', 'var(--ac)', 'mail'],
      send: ['답변 전송', '액션', 'var(--ac)', 'send'],
    };
    const add = (k) => {
      const n = N[k];
      if (!n) return;
      if ($$('.fn', flow).length) {
        const c = document.createElement('div');
        c.className = 'cn';
        flow.insertBefore(c, empty);
      }
      const e = document.createElement('div');
      e.className = 'fn';
      e.innerHTML = `<span class="ic" style="background:${n[2]}"><svg class="i"><use href="#${n[3]}"></use></svg></span><span>${n[0]}<small>${n[1]}</small></span><button class="x" aria-label="삭제"><svg class="i"><use href="#x"></use></svg></button>`;
      $('.x', e).onclick = () => {
        const p = e.previousElementSibling,
          nx = e.nextElementSibling;
        if (p && p.classList.contains('cn')) p.remove();
        else if (nx && nx.classList.contains('cn')) nx.remove();
        e.remove();
        clear();
      };
      flow.insertBefore(e, empty);
      clear();
    };
    const clear = () => {
      $$('.fn', flow).forEach((f) => f.classList.remove('act', 'ok'));
      res.classList.remove('on');
      st.className = 'st';
      stb.textContent = '편집 중';
    };
    const reset = () => {
      $$('.fn,.cn', flow).forEach((e) => e.remove());
      ['chat', 'doc'].forEach(add);
    };
    const cvs = $('.cvs', lab);
    $$('.pal button', lab).forEach((b) => {
      b.draggable = true;
      b.onclick = () => add(b.dataset.k);
      b.ondragstart = (e) => {
        e.dataTransfer.setData('text/plain', b.dataset.k);
        e.dataTransfer.effectAllowed = 'copy';
        lab.classList.add('dragging');
      };
      b.ondragend = () => lab.classList.remove('dragging', 'over');
    });
    cvs.ondragover = (e) => {
      e.preventDefault();
      e.dataTransfer.dropEffect = 'copy';
      lab.classList.add('over');
    };
    cvs.ondragleave = (e) => {
      if (!cvs.contains(e.relatedTarget)) lab.classList.remove('over');
    };
    cvs.ondrop = (e) => {
      e.preventDefault();
      lab.classList.remove('over', 'dragging');
      add(e.dataTransfer.getData('text/plain'));
    };
    $('[data-run]', lab).onclick = () => {
      const f = $$('.fn', flow);
      if (!f.length) return;
      clear();
      st.className = 'st run';
      stb.textContent = '실행 중';
      f.forEach((e, i) => {
        setTimeout(() => {
          f.forEach((x) => x.classList.remove('act'));
          e.classList.add('act');
          if (i) f[i - 1].classList.add('ok');
        }, i * 650);
      });
      setTimeout(() => {
        f.forEach((x) => {
          x.classList.remove('act');
          x.classList.add('ok');
        });
        st.className = 'st done';
        stb.textContent = '실행 완료';
        res.classList.add('on');
      }, f.length * 650 + 200);
    };
    $('[data-reset]', lab).onclick = reset;
    reset();
  }

  /* user portal demo */
  const upv = $('.upv');
  if (upv) {
    const pan = upv.closest('.hpan'),
      q = $('.ucb .q', upv),
      a = $('.ucb .a', upv),
      ty = $('.typing', upv),
      bots = $$('.ub2', upv),
      kp = $('.ukpi .pr i', upv);
    let T = [];
    const play = () => {
      T.forEach((id) => window.clearTimeout(id));
      T = [];
      [q, a, ty].forEach((e) => e.classList.remove('on'));
      bots.forEach((b, i) => b.classList.toggle('on', i === 3));
      kp.style.transition = 'none';
      kp.style.width = '0';
      void kp.offsetWidth;
      kp.style.transition = '';
      bots.forEach((b, i) => b.classList.toggle('on', i === 0));
      q.classList.add('on');
      ty.classList.add('on');
      T.push(setTimeout(() => (kp.style.width = '100%'), 100));
      T.push(
        setTimeout(() => {
          ty.classList.remove('on');
          a.classList.add('on');
        }, 1000),
      );
    };
    const mo = new MutationObserver(() => {
      if (pan.classList.contains('on')) play();
    });
    mo.observe(pan, { attributes: true, attributeFilter: ['class'] });
    s.onDispose(() => mo.disconnect());
  }
}
